export const SocialMediaIcons = {
  instagram: '/social_media/ig.webp',
  facebook: '/social_media/facebook.webp',
  tiktok: '/social_media/tiktok.webp',
  google_maps: '/social_media/maps.webp',
  whatsapp: '/social_media/whatsapp.webp',
} as const;
